/** @deprecated **/
export const DEVICE = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '479px',
  tablet: '768px',
  laptop: '1025px',
  laptopM: '1126px',
  laptopML: '1300px',
  laptopL: '1440px',
  laptopXL: '1640px',
  desktop: '2560px',
};
